export enum RatingButtonType{
    Like,
    Dislike
}